import { create } from 'zustand';

interface EncaissementState {
    /** Acomba customer id → the relance the operator opened the receipt window from, null for an expected one. */
    pendingByCustomer: Record<number, string | null>;
    setPending: (customerExternalId: number, relanceId: string | null) => void;
}

/**
 * Correlates the completion AcombaGO posts back, which names only a customer, with the relance the
 * operator left from.
 *
 * Keyed by customer rather than held in a single slot: starting a second collection must not orphan
 * the first, whose receipt may still be saved afterwards. Entries are never cleared — the window
 * stays open, and each further receipt saved there is its own collection against the same relance.
 */
export const useEncaissementStore = create<EncaissementState>((set) => ({
    pendingByCustomer: {},
    setPending: (customerExternalId, relanceId) =>
        set((state) => ({
            pendingByCustomer: { ...state.pendingByCustomer, [customerExternalId]: relanceId },
        })),
}));
